import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { ImportOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

const TemplateInfoModal = ({ template, open, onClose, history }) => {
    if (!template) return null;

    const copy = template.longCopy || {};

    const handleImport = () => {
        onClose();
        history.push({
            pathname: '/group/create',
            state: { template },
        });
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            title={
                <Space size={10}>
                    <span style={{ fontSize: 26 }}>{template.icon}</span>
                    <span style={{ fontSize: 18, fontWeight: 600 }}>{template.name}</span>
                </Space>
            }
            width={560}
            footer={[
                <Button key="cancel" onClick={onClose}>Cancel</Button>,
                <Button
                    key="import"
                    type="primary"
                    icon={<ImportOutlined />}
                    onClick={handleImport}
                    style={{ backgroundColor: '#4CAF50', borderColor: '#4CAF50' }}
                >
                    Import
                </Button>,
            ]}
        >
            {copy.headline && (
                <Title level={5} style={{ marginTop: 0, marginBottom: 8, color: '#1f2937' }}>
                    {copy.headline}
                </Title>
            )}

            {copy.summary && (
                <Paragraph style={{ color: '#4b5563', marginBottom: 16 }}>
                    {copy.summary}
                </Paragraph>
            )}

            {copy.whatYouCanDo?.length > 0 && (
                <div style={{ marginBottom: 16 }}>
                    <Text strong style={{ display: 'block', marginBottom: 6 }}>What you can do</Text>
                    <ul style={{ paddingLeft: 20, margin: 0, color: '#4b5563', listStyleType: 'disc' }}>
                        {copy.whatYouCanDo.map((item, i) => (
                            <li key={i} style={{ marginBottom: 4 }}>{item}</li>
                        ))}
                    </ul>
                </div>
            )}

            {copy.examples?.length > 0 && (
                <div
                    style={{
                        background: '#f6ffed',
                        border: '1px solid #d9f7be',
                        padding: '12px 16px',
                        borderRadius: 4,
                    }}
                >
                    <Text strong style={{ display: 'block', marginBottom: 6 }}>Examples</Text>
                    <ul style={{ paddingLeft: 20, margin: 0, color: '#4b5563', listStyleType: 'disc' }}>
                        {copy.examples.map((item, i) => (
                            <li key={i} style={{ marginBottom: 4 }}>{item}</li>
                        ))}
                    </ul>
                </div>
            )}
        </Modal>
    );
};

export default withRouter(TemplateInfoModal);
